import { UrlPaths } from '../../constants';
import { queryPathBuilder } from '../../util/queryPathBuilder';
import {
  CREATE_CONSIGNMENT_ORDER_BILLING,
  DELETE_CONSIGNMENT_ORDER_BILLING,
  GET_CONSIGNMENT_ORDER_BILLING_BY_CONSIGNMENT_ORDER_ID,
  GET_CONSIGNMENT_ORDER_BILLING_BY_ID,
  GET_CONSIGNMENT_ORDER_BILLINGS,
  UPDATE_CONSIGNMENT_ORDER_BILLING,
} from '../types';
import { get, post, put, remove } from './Action';

const basePath = '/consignment-order-billing';

export const getConsignmentOrderBillings = (params) => async (dispatch) => {
  const queryParams = queryPathBuilder(params);
  return await dispatch(
    get(`${basePath}${queryParams}`, getConsignmentOrderBillingsDS, true)
  );
};

export const getConsignmentOrderBillingsByOrderId =
  (orderId) => async (dispatch) => {
    return await dispatch(
      get(
        `${basePath}/${orderId}/consignment-order-billing`,
        getConsignmentOrderBillingByConsigmentOrderIdDS
      )
    );
  };

export const createConsignmentOrderBilling = (data) => async (dispatch) => {
  return await dispatch(
    post(`${basePath}/create`, data, createConsignmentOrderBillingDS)
  );
};

export const changeStatusConsignmentOrderBilling = (id) => async (dispatch) => {
  return await dispatch(
    put(`${basePath}/${id}/approve`, {}, updateConsignmentOrderBillingDS)
  );
};

export const deleteConsignmentOrderBilling = (id) => async (dispatch) => {
  const response = await dispatch(
    remove(UrlPaths.CONSIGNMENT_ORDER_BILLING_DELETE(basePath, id))
  );
  dispatch(deleteConsignmentOrderBillingDS(id));
  return response;
};

export const getConsignmentOrderBillingsById = (id) => async (dispatch) => {
  return await dispatch(
    get(`${basePath}/${id}`, getConsignmentOrderBillingByIdDS)
  );
};

export const updateConsignmentOrderBilling = (id, data) => async (dispatch) => {
  return await dispatch(
    put(`${basePath}/${id}/update`, data, updateConsignmentOrderBillingDS)
  );
};

const getConsignmentOrderBillingsDS = (billings) => ({
  type: GET_CONSIGNMENT_ORDER_BILLINGS,
  payload: billings.items,
});

const getConsignmentOrderBillingByConsigmentOrderIdDS = (billing) => ({
  type: GET_CONSIGNMENT_ORDER_BILLING_BY_CONSIGNMENT_ORDER_ID,
  payload: billing,
});

const createConsignmentOrderBillingDS = (billing) => ({
  type: CREATE_CONSIGNMENT_ORDER_BILLING,
  payload: billing,
});

const updateConsignmentOrderBillingDS = (billing) => ({
  type: UPDATE_CONSIGNMENT_ORDER_BILLING,
  payload: billing,
});

const deleteConsignmentOrderBillingDS = (order) => ({
  type: DELETE_CONSIGNMENT_ORDER_BILLING,
  payload: order,
});

const getConsignmentOrderBillingByIdDS = (billing) => ({
  type: GET_CONSIGNMENT_ORDER_BILLING_BY_ID,
  payload: billing,
});
